import * as React from "react";
import { useContext } from "react";
import { EditProjectContext } from "../../../EditProjectContext";
import { DropDownListType } from "../../LtlTab/LtlTabTable/RouteCell/DropDownListType";
import { updateRoutePropertyOnProject } from "./UpdateRoutePropertyOnProject";
import { isProjectReadOnly } from "../../../IsProjectReadOnly";
import { DropDownList } from "../../../../../Layout/Inputs/DropDownList";
import { setChangedRoute } from "./SetChangedRoute";
import { RouteNumberAreaInputProps } from "./RouteNumberAreaInputProps";

export const Equipment = ({ route, disabled = false }: RouteNumberAreaInputProps) => {
  const projectContextProps = useContext(EditProjectContext);
  const { project } = projectContextProps;

  const list: Array<DropDownListType<string>> = [
    { text: "Euro", value: "Euro" },
    { text: "Mega", value: "Mega" },
    { text: "Jumbo", value: "Jumbo" },
    { text: "Giga", value: "Giga" },
    { text: "Avia", value: "Avia" },
    { text: "Railmax-Swap", value: "Railmax-Swap" },
    { text: "Eurotunnel-Swap", value: "Eurotunnel-Swap" },
    { text: "Tops 22,9t Mega", value: "Tops 22,9t Mega" },
    { text: "Tops 22,9t Euro", value: "Tops 22,9t Euro" },
    { text: "Megacombi-Swap I", value: "Megacombi-Swap I" },
    { text: "Megacombi-Swap II", value: "Megacombi-Swap II" },
    { text: "Megacombi-Swap III", value: "Megacombi-Swap III" },
    { text: "ADR Euro", value: "ADR Euro" },
    { text: "ADR Mega", value: "ADR Mega" },
    { text: "Other", value: "Other" },
  ];

  return (
    <DropDownList
      label="Equipment"
      list={list}
      value={route.Equipment || ""}
      onChange={(equipmentValue) => {
        updateRoutePropertyOnProject(
          "Equipment",
          equipmentValue,
          route.RouteNumber || "",
          projectContextProps
        );
        setChangedRoute(route, projectContextProps, equipmentValue);
      }}
      disabled={isProjectReadOnly(project) || disabled}
    />
  );
};
